import { Link } from "react-router-dom";
import EligibilitySimulator from "../components/EligibilitySimulator";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { CONTACT } from "../data/content";

export default function Devis() {
  return (
    <div data-testid="devis-page" className="pt-32 pb-24 relative overflow-hidden">
      <div className="blob" style={{ background: "#7DD923", width: 500, height: 500, top: 100, left: -200, opacity: 0.1 }} />
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 relative z-10">
        <div className="lg:col-span-5">
          <div className="eyebrow">Étude gratuite</div>
          <h1 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95] tracking-tight">
            Votre projet<br/>en <span className="text-[#7DD923]">2 minutes</span>
          </h1>
          <p className="text-white/70 mt-6 text-lg leading-relaxed">
            Remplissez ce formulaire pour recevoir une estimation personnalisée de vos aides et une étude thermique gratuite.
          </p>
          <ul className="mt-8 space-y-3">
            {[
              "100% gratuit, sans engagement",
              "Estimation instantanée de vos aides",
              "Rappel d'un expert sous 24h",
              "Devis clair et détaillé",
              "Accompagnement complet MaPrimeRénov' + CEE",
            ].map((t) => (
              <li key={t} className="flex items-start gap-2 text-white/80">
                <CheckCircle2 className="w-5 h-5 text-[#7DD923] mt-0.5 flex-shrink-0" /> {t}
              </li>
            ))}
          </ul>
          <div className="mt-8 glass rounded-2xl p-5">
            <div className="text-xs uppercase tracking-widest text-white/40">Vous préférez discuter ?</div>
            <div className="mt-2 font-display text-2xl text-white">{CONTACT.phoneDisplay}</div>
            <a href={`tel:${CONTACT.phoneLink}`} className="btn-secondary mt-3 !py-2 !px-4 text-xs" data-testid="devis-call-btn">Nous appeler <ArrowRight className="w-4 h-4" /></a>
          </div>
        </div>
        <div className="lg:col-span-7">
          <EligibilitySimulator />
        </div>
      </div>
    </div>
  );
}
